import type {Vsop87Element, Vsop87Group} from '@app/types/Vsop87Types';

const VSOP87_L0: Vsop87Element = [
    [5.48129294299],
    [0.09260408252, 0.8910642153, 74.7815985673],
    [0.01504247826, 3.62719262195, 1.4844727083],
    [0.00365981718, 1.89962189068, 73.297125859],
    [0.00272328132, 3.35823710524, 149.5631971346],
    [0.00070328499, 5.39254431993, 63.7358983034],
    [0.00068892609, 6.09292489045, 76.2660712756],
    [0.00061998592, 2.26952040469, 2.9689454166],
    [0.00061950714, 2.85098907565, 11.0457002639],
    [0.00026468869, 3.14152087888, 71.8126531507],
    [0.00025710505, 6.11379842935, 454.9093665273],
    [0.00021078897, 4.36059465144, 148.0787244263],
    [0.00017818665, 1.74436982544, 36.6485629295],
    [0.00014613471, 4.73732047977, 3.9321532631],
    [0.00011162535, 5.82681993692, 224.3447957019],
    [0.00010997934, 0.48865493179, 138.5174968707],
    [0.00009527487, 2.95516893093, 35.1640902212],
    [0.00007545543, 5.23626440666, 109.9456887885],
    [0.0000422017, 3.23328535514, 70.8494453042],
    [0.0000405185, 2.27754158724, 151.0476698429],
    [0.00003490352, 5.48305567292, 146.594251718],
    [0.00003354607, 1.06549008887, 4.4534181249],
    [0.00003144093, 4.75199307603, 77.7505439839],
    [0.00002926671, 4.62903695486, 9.5612275556],
    [0.0000292241, 5.3523674338, 85.8272988312],
    [0.0000227279, 4.36600802756, 70.3281804424],
    [0.00002148599, 0.60745800902, 38.1330356378],
    [0.00002051209, 1.51773563459, 0.1118745846],
    [0.00001991726, 4.92437290826, 277.0349937414],
    [0.0000166691, 3.62744580852, 380.12776796],
    [0.00001533223, 2.58593414266, 52.6901980395],
    [0.00001376208, 2.04281409054, 65.2203710117],
    [0.000013721, 4.19641615561, 111.4301614968],
    [0.00001284183, 3.11346336879, 202.2533951741],
    [0.00001281641, 0.54269869505, 222.8603229936],
    [0.00001244342, 0.91612680579, 2.4476805548],
    [0.00001220998, 0.19901396193, 108.4612160802],
    [0.00001150993, 4.17898207045, 33.6796175129],
    [0.00001150416, 0.93344454002, 3.1813937377],
    [0.00001090461, 1.77501638912, 12.5301729722],
    [0.00001072008, 0.23564502877, 62.2514255951],
    [0.00000946195, 1.19249463066, 127.4717966068],
];

const VSOP87_L1: Vsop87Element = [
    [75.02543121646],
    [0.00154458244, 5.24201658072, 74.7815985673],
    [0.00024456413, 1.71255705309, 1.4844727083],
    [0.00009257828, 0.42844639064, 11.0457002639],
    [0.00008265977, 1.5022003511, 63.7358983034],
    [0.00007841715, 1.31983607251, 149.5631971346],
    [0.00003899105, 0.46483574024, 3.9321532631],
    [0.00002283777, 4.17367533997, 76.2660712756],
    [0.000019266, 0.53013080152, 2.9689454166],
    [0.00001232727, 1.58634458237, 70.8494453042],
    [0.00000791206, 5.43641224143, 3.1813937377],
    [0.00000766954, 1.99555409575, 73.297125859],
    [0.00000481671, 2.98401996914, 85.8272988312],
    [0.00000449798, 4.13826237508, 138.5174968707],
    [0.000004456, 3.72300400331, 224.3447957019],
    [0.00000426554, 4.73126059388, 71.8126531507],
    [0.00000353752, 2.58324496886, 148.0787244263],
    [0.00000347735, 2.45372261286, 9.5612275556],
    [0.00000317084, 5.57855232072, 52.6901980395],
    [0.00000205585, 2.36263144251, 2.4476805548],
    [0.00000189068, 4.20242881378, 56.6223513026],
    [0.00000183762, 0.28371004654, 151.0476698429],
    [0.0000017992, 5.68367730922, 12.5301729722],
];

const VSOP87_L2: Vsop87Element = [
    [0.00053033277],
    [0.00002357636, 2.26014661705, 74.7815985673],
    [0.00000769129, 4.52561041823, 11.0457002639],
    [0.00000551533, 3.25814281023, 63.7358983034],
    [0.00000541532, 2.27573907424, 3.9321532631],
    [0.00000529473, 4.92348433826, 1.4844727083],
    [0.00000257521, 3.69059216858, 3.1813937377],
    [0.00000238835, 5.85806638405, 149.5631971346],
    [0.00000181904, 6.21763603405, 70.8494453042],
    [0.00000053504, 1.44225240953, 76.2660712756],
    [0.00000049401, 6.03101301723, 56.6223513026],
    [0.00000044753, 3.90904910523, 2.4476805548],
    [0.0000004453, 0.81152639478, 85.8272988312],
    [0.00000038222, 1.78467827781, 52.6901980395],
    [0.00000037403, 4.46228598032, 2.9689454166],
    [0.00000033029, 0.86388149962, 9.5612275556],
    [0.00000029423, 5.09818697708, 73.297125859],
];

const VSOP87_L3: Vsop87Element = [
    [0.00000120936, 0.02418789918, 74.7815985673],
    [0.00000068064, 4.12084267733, 3.9321532631],
    [0.00000052828, 2.3896406126, 11.0457002639],
    [0.00000045806],
    [0.000000453, 2.0442379841, 3.1813937377],
    [0.00000043754, 2.95965039734, 1.4844727083],
    [0.00000024969, 4.88741307918, 63.7358983034],
    [0.00000021061, 4.54511486862, 70.8494453042],
];

const VSOP87_L4: Vsop87Element = [
    [0.00000005599, 4.57882424417, 74.7815985673],
    [0.00000003203, 0.34623003207, 11.0457002639],
];

const VSOP87_L5: Vsop87Element = [];

const VSOP87_B0: Vsop87Element = [
    [0.01346277639, 2.61877810545, 74.7815985673],
    [0.00062341405, 5.08111175856, 149.5631971346],
    [0.00009963744, 1.61603876357, 76.2660712756],
    [0.00009926151, 0.57630387917, 73.297125859],
    [0.00003259455, 1.2611938596, 224.3447957019],
    [0.00002972318, 2.24367035538, 1.4844727083],
    [0.00002010257, 6.05550401088, 148.0787244263],
    [0.00001522172, 0.27960386377, 63.7358983034],
    [0.00000924055, 4.03822927853, 151.0476698429],
    [0.00000760624, 6.14000431923, 71.8126531507],
    [0.00000522309, 3.3208519477, 138.5174968707],
    [0.0000046263, 0.74256727574, 85.8272988312],
    [0.00000436843, 3.38082524317, 529.6909650946],
    [0.00000434625, 0.34065281858, 77.7505439839],
    [0.00000430668, 3.55445034854, 213.299095438],
    [0.00000420265, 5.21279984788, 11.0457002639],
    [0.00000244698, 0.78795150326, 2.9689454166],
    [0.00000232649, 2.25716421383, 222.8603229936],
];

const VSOP87_B1: Vsop87Element = [
    [0.00206366162, 4.12394311407, 74.7815985673],
    [0.0000856323, 0.33819986165, 149.5631971346],
    [0.00001725703, 2.12193159895, 73.297125859],
    [0.00001374449],
    [0.0000136886, 3.06861722047, 76.2660712756],
    [0.00000450639, 3.77656180977, 1.4844727083],
    [0.00000399847, 2.84767037795, 224.3447957019],
    [0.00000307214, 1.25456766737, 148.0787244263],
    [0.00000154336, 3.78575467747, 63.7358983034],
    [0.00000112432, 5.57299891505, 151.0476698429],
    [0.00000110888, 5.32888676461, 138.5174968707],
    [0.00000083493, 3.59152795558, 71.8126531507],
];

const VSOP87_B2: Vsop87Element = [
    [0.00009211656, 5.80044305785, 74.7815985673],
    [0.00000556926],
    [0.00000286265, 2.17729776353, 149.5631971346],
    [0.00000094969, 3.84237569809, 73.297125859],
    [0.00000045419, 4.87822046064, 76.2660712756],
    [0.00000020107, 5.46264485369, 1.4844727083],
    [0.00000014793, 0.87983715652, 138.5174968707],
];

const VSOP87_B3: Vsop87Element = [
    [0.00000267832, 1.25097888291, 74.7815985673],
    [0.00000006154, 4.00663614486, 149.5631971346],
    [0.00000003361, 5.77804694935, 73.297125859],
];

const VSOP87_B4: Vsop87Element = [[0.00000005719, 2.85499529315, 74.7815985673]];

const VSOP87_B5: Vsop87Element = [];

const VSOP87_R0: Vsop87Element = [
    [19.21264847881],
    [0.88784984055, 5.60377526994, 74.7815985673],
    [0.03440835545, 0.32836098991, 73.297125859],
    [0.02055653495, 1.78295170028, 149.5631971346],
    [0.00649321851, 4.52247298119, 76.2660712756],
    [0.00602248144, 3.86003820462, 63.7358983034],
    [0.00496404171, 1.40139934716, 454.9093665273],
    [0.00338525522, 1.58002682946, 138.5174968707],
    [0.00243508222, 1.57086595074, 71.8126531507],
    [0.00190521915, 1.99809364502, 1.4844727083],
    [0.00161858251, 2.79137863469, 148.0787244263],
    [0.00143705902, 1.38368574483, 11.0457002639],
    [0.00093192359, 0.17437193645, 36.6485629295],
    [0.00089805842, 3.66105366329, 109.9456887885],
    [0.00071424265, 4.24509327405, 224.3447957019],
    [0.00046677322, 1.39976563936, 35.1640902212],
    [0.00039025681, 3.36234710692, 277.0349937414],
    [0.00039009624, 1.66971128869, 70.8494453042],
    [0.0003675516, 3.88648934736, 146.594251718],
    [0.00030348875, 0.70100446346, 151.0476698429],
    [0.00029156264, 3.18056174556, 77.7505439839],
    [0.00025785805, 3.78537741503, 85.8272988312],
    [0.0002562036, 5.25656292802, 380.12776796],
    [0.00022637152, 0.72519137745, 529.6909650946],
    [0.00020473163, 2.79639811626, 70.3281804424],
    [0.00020471584, 1.555889615, 202.2533951741],
    [0.00017900561, 0.55455488605, 2.9689454166],
    [0.00015502809, 5.35405037603, 38.1330356378],
    [0.00014701566, 4.90434406648, 108.4612160802],
    [0.00012896507, 2.62154018241, 111.4301614968],
    [0.00012328151, 5.96039150918, 127.4717966068],
    [0.00011959355, 1.75044072173, 984.6003316219],
    [0.00011852996, 0.99342814582, 52.6901980395],
    [0.00011696085, 3.29825599114, 3.9321532631],
    [0.00011494701, 0.43774027872, 65.2203710117],
    [0.00010792699, 1.42104858472, 213.299095438],
    [0.00009111446, 4.99638600045, 62.2514255951],
    [0.0000842055, 5.25350716616, 222.8603229936],
    [0.00008402147, 5.03877516489, 415.5524906121],
    [0.00007449125, 0.79491905956, 351.8165923087],
    [0.00007329454, 3.9727752784, 183.2428146475],
    [0.0000604637, 5.67960948357, 78.7137518304],
    [0.00005524133, 3.11499484161, 9.5612275556],
];

const VSOP87_R1: Vsop87Element = [
    [0.0147989637, 3.67205705317, 74.7815985673],
    [0.00071212085, 6.22601006675, 63.7358983034],
    [0.00068626972, 6.13411265052, 149.5631971346],
    [0.00021468152, 2.6017670427, 76.2660712756],
    [0.00020857262, 5.24625494219, 11.0457002639],
    [0.00011405346, 0.01848461561, 70.8494453042],
    [0.00007496775, 0.42360033283, 73.297125859],
    [0.000042438, 1.41692350371, 85.8272988312],
    [0.00003926694, 3.15513991323, 71.8126531507],
    [0.00003578446, 2.31160668309, 224.3447957019],
    [0.00003505936, 2.58354048851, 138.5174968707],
    [0.00003228835, 5.25499602896, 3.9321532631],
    [0.0000306001, 0.15321893225, 1.4844727083],
    [0.00002564251, 0.98076846352, 148.0787244263],
    [0.00002429445, 3.99440122468, 52.6901980395],
    [0.00001644719, 2.65349313124, 127.4717966068],
    [0.00001583766, 1.43045619196, 78.7137518304],
    [0.00001508028, 5.05996325425, 151.0476698429],
    [0.00001489525, 2.67559167316, 56.6223513026],
    [0.00001413112, 4.57461892062, 202.2533951741],
    [0.00001403237, 1.36985349744, 77.7505439839],
    [0.0000122822, 1.04703640149, 62.2514255951],
    [0.00001032731, 0.26459059027, 131.4039498699],
    [0.00000992085, 2.17168865909, 65.2203710117],
    [0.00000861867, 5.05530802218, 351.8165923087],
    [0.00000744445, 3.07640148939, 35.1640902212],
    [0.0000068747, 2.49912565674, 77.962992305],
    [0.00000646851, 4.4729042291, 70.3281804424],
    [0.00000623602, 0.8625307382, 9.5612275556],
    [0.00000604362, 0.90717667985, 984.6003316219],
];

const VSOP87_R2: Vsop87Element = [
    [0.00022439904, 0.6995311876, 74.7815985673],
    [0.00004727037, 1.69901641488, 63.7358983034],
    [0.00001681903, 4.64833551727, 70.8494453042],
    [0.00001649559, 3.0966007898, 11.0457002639],
    [0.00001433755, 3.52119917947, 149.5631971346],
    [0.00000770188],
    [0.00000500429, 6.17229032223, 76.2660712756],
    [0.00000461009, 0.76676632849, 3.9321532631],
    [0.00000390371, 4.49605283502, 56.6223513026],
    [0.00000389945, 5.52673426377, 85.8272988312],
    [0.00000292097, 0.20389012095, 52.6901980395],
    [0.00000286579, 3.5335768327, 73.297125859],
    [0.00000272898, 3.84707823651, 138.5174968707],
    [0.00000219674, 1.96418942891, 131.4039498699],
    [0.00000215788, 0.84812474187, 77.962992305],
    [0.00000205449, 3.24758017121, 78.7137518304],
    [0.00000148554, 4.89840863841, 127.4717966068],
];

const VSOP87_R3: Vsop87Element = [
    [0.00001164382, 4.73453291602, 74.7815985673],
    [0.00000212367, 3.34255734999, 63.7358983034],
    [0.00000196408, 2.98004616318, 70.8494453042],
    [0.00000104527, 0.95807937648, 11.0457002639],
    [0.0000007254, 0.99701907912, 149.5631971346],
    [0.00000071681, 0.02528455665, 56.6223513026],
];

const VSOP87_R4: Vsop87Element = [[0.00000052996, 3.00838033088, 74.7815985673]];

const VSOP87_R5: Vsop87Element = [];

export const VSOP87_X: Vsop87Group = [VSOP87_L0, VSOP87_L1, VSOP87_L2, VSOP87_L3, VSOP87_L4, VSOP87_L5];
export const VSOP87_Y: Vsop87Group = [VSOP87_B0, VSOP87_B1, VSOP87_B2, VSOP87_B3, VSOP87_B4, VSOP87_B5];
export const VSOP87_Z: Vsop87Group = [VSOP87_R0, VSOP87_R1, VSOP87_R2, VSOP87_R3, VSOP87_R4, VSOP87_R5];
